import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import useAuth from '../../hooks/useAuth';

const AuthGuard = ({ children }) => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const cmpId = JSON.parse(localStorage.getItem('cmpId'));

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/auth/signin-2', { replace: true });
    }
    else {
      if(isLoggedIn && !cmpId){
        navigate('/auth/tabs-auth', { replace: true });
      }
    }
  }, [isLoggedIn, navigate, cmpId]);

  return <React.Fragment>{children}</React.Fragment>;
};

export default AuthGuard;
